export default {
  label: {
    id: 'bo_sellers-orders-components-orders_table-actions-create_backship_labels',
    defaultMessage: 'Create backship labels',
  },
  modalMessage: {
    id: 'bo_sellers-orders-components-orders_table-actions-print_backship_labels_modal_message',
    defaultMessage:
      'You can only create backship labels for selected "To be shipped" or "Shipped" orders. Is that cool with you?',
  },
  modalConfirm: {
    id: 'bo_sellers-orders-components-orders_table-actions-confirm_print_backship_labels',
    defaultMessage: 'Yes, create backship labels',
  },
  modalCancel: {
    id: 'bo_sellers-orders-components-orders_table-actions-cancel_backship_labels',
    defaultMessage: "No, don't create them",
  },
  toastSuccess: {
    id: 'bo_sellers-orders-components-orders_table-actions-create_backship_labels_success',
    defaultMessage: 'You can find the backship labels in the File library',
  },
} as const
